import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import Select from "react-select";
import * as Yup from "yup";
import { addAreaCode } from "../../api/areacode";
import Loader from "./../../component/Loader";
import { areaCodeDetailSelector, details, FetchAreaCodeDetail } from "./slice";
import BackButton from "./../../component/BackButton";
function AddAreaCode() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector(areaCodeDetailSelector);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  const [selectedCompany, setSelectedCompany] = useState(0);

  useEffect(() => {
    if (id) {
      dispatch(FetchAreaCodeDetail(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    return () => {
      dispatch(details(null));
    };
  }, [dispatch]);

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <BackButton />
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
            <h3>Add Region</h3>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-12">
            <Formik
              initialValues={{
                areacode: data?.areacode || "",
                company_id: data?.company_id ? Number(data.company_id) : "",
              }}
              enableReinitialize={true}
              validationSchema={Yup.object({
                areacode: Yup.string().required("Required"),
              })}
              onSubmit={(values, { setSubmitting }) => {
                setLoading(true);

                addAreaCode({
                  areacode_id: id || 0,
                  areacode: values.areacode,
                  company_id: values.company_id,
                }).then((res) => {
                  setLoading(false);
                  if (res?.code === 1) {
                    toast.success(res?.message);
                    navigate("/area-code", { replace: true });
                  } else {
                    toast.error(res?.message, {  autoClose: false,  closeButton: true});
                  }
                });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFormikState,
                setFieldValue,
                /* and other goodies */
              }) => (
                <form className="form-style" onSubmit={handleSubmit}>
                  <div className="row">
                  {Array.isArray(companyOptions) && companyOptions.length > 0 && (
                      <div className="col-sm-12 col-md-12 mb-4">
                        <div className="form-group">
                          <label className="fw-bold">Company</label>
                          {errors.company_id &&
                            touched.company_id && (
                              <span className="text-red ms-1">
                                {errors.company_id}
                              </span>
                            )}
                         <Select
                            className="form-control"
                            options={companyOptions}
                            isSearchable
                            name="company_id"
                            placeholder="Select a company..."
                            value={companyOptions.find(option => option.value === values.company_id)}
                            onChange={option => setFieldValue('company_id', option ? Number(option.value) : null)}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                      )}
                    <div className="col-sm-12 col-md-12 mb-5">
                      <div className="form-group">
                        <label className="fw-bold">Region Name</label>
                        <div className="input-container">
                          <input
                            type="text"
                            className="form-control pl-5"
                            placeholder="Region Name"
                            name="areacode"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.areacode}
                          />
                          <img
                            src="assets/images/First-Name.png"
                            className="input-img"
                            alt=""
                          />
                        </div>
                        {errors.areacode && touched.areacode && (
                          <div className="text-red">{errors.areacode}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-12 text-center">
                      <button type="submit" className="btn btn-save">
                        {loading ? <Loader /> : "Done"}
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </article>
  );
}

export default AddAreaCode;
